import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { useDisabledDatePresets } from '@/App/tiles/shared/useDisabledDatePresets.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorPremiumDateData,
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export function PremiumDate() {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();

  const currencyPair = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'currencyPair'));

  const disabledDatePresets = useDisabledDatePresets(tileId, currencyPair);

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const { premiumDate, premiumDateTenor } = useAppSelector((state) =>
    selectForwardAccumulatorPremiumDateData(state, tileId),
  );

  const handlePremiumPaymentDateSelected = (dateOrTenor: string) => {
    sgwtWebAnalytics?.trackEvent('ForwardAccumulator', 'Premium payment date selected', dateOrTenor);

    check({
      premiumDate: dateOrTenor,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="forwardAccumulator.form.premiumDate">
      <TradeCaptureValidationWrapper validation={validation?.premiumDate}>
        <DatePickerWithTenorNext
          data-e2e="premium-payment-date"
          date={premiumDate}
          tenor={premiumDateTenor}
          onChange={handlePremiumPaymentDateSelected}
          disablePresets={disabledDatePresets}
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
}
